import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

import config from '@seller-area/config';
import { ToastNotificationProvider } from '@seller-area/contexts/toast-notification';
import {
  SALES_SIMULATOR_GD_NEW_SIMULATION_PATH,
  SALES_SIMULATOR_GD_PATH,
  SALES_SIMULATOR_GD_RESULT_PATH,
  SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH,
  SALES_SIMULATOR_ML_LEAD_PATH,
  SALES_SIMULATOR_ML_NEW_SIMULATION_PATH,
  SALES_SIMULATOR_ML_PATH,
} from '@seller-area/routers/constants';

const SalesSimulatorMlHistoryPage = lazy(() => import('@seller-area/pages/sales-simulator/ml-history'));
const SalesSimulatorMlLeadPage = lazy(() => import('@seller-area/pages/sales-simulator/ml-lead'));
const SalesSimulatorMlNewSimulationPage = lazy(() => import('@seller-area/pages/sales-simulator/ml-new-simulation'));
const SalesSimulatorMlContractRequestPage = lazy(
  () => import('@seller-area/pages/sales-simulator/ml-contract-request'),
);
const SalesSimulatorGdHistoryPage = lazy(() => import('@seller-area/pages/sales-simulator/gd-history'));
const SalesSimulatorGdNewSimulationPage = lazy(() => import('@seller-area/pages/sales-simulator/gd-new-simulation'));
const SalesSimulatorGdResultPage = lazy(() => import('@seller-area/pages/sales-simulator/gd-result'));

const simulatorPage = (page: JSX.Element) => (
  <ToastNotificationProvider>
    <Suspense fallback={null}>{page}</Suspense>
  </ToastNotificationProvider>
);

export const simulatorRoutes = (): JSX.Element[] => [
  <Route
    key={SALES_SIMULATOR_ML_PATH}
    path={SALES_SIMULATOR_ML_PATH}
    element={simulatorPage(<SalesSimulatorMlHistoryPage />)}
  />,
  <Route
    key={SALES_SIMULATOR_ML_NEW_SIMULATION_PATH}
    path={SALES_SIMULATOR_ML_NEW_SIMULATION_PATH}
    element={simulatorPage(<SalesSimulatorMlNewSimulationPage />)}
  />,
  ...(config.SELLER_CONTRACTS_ENABLED
    ? [
        <Route
          key={SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH}
          path={SALES_SIMULATOR_ML_CONTRACT_REQUEST_PATH}
          element={simulatorPage(<SalesSimulatorMlContractRequestPage />)}
        />,
      ]
    : []),
  <Route
    key={SALES_SIMULATOR_GD_PATH}
    path={SALES_SIMULATOR_GD_PATH}
    element={simulatorPage(<SalesSimulatorGdHistoryPage />)}
  />,
  <Route
    key={SALES_SIMULATOR_GD_NEW_SIMULATION_PATH}
    path={SALES_SIMULATOR_GD_NEW_SIMULATION_PATH}
    element={simulatorPage(<SalesSimulatorGdNewSimulationPage />)}
  />,
];

export const simulatorStandaloneRoutes = (): JSX.Element[] => [
  <Route
    key={SALES_SIMULATOR_ML_LEAD_PATH}
    path={SALES_SIMULATOR_ML_LEAD_PATH}
    element={simulatorPage(<SalesSimulatorMlLeadPage />)}
  />,
  <Route
    key={SALES_SIMULATOR_GD_RESULT_PATH}
    path={SALES_SIMULATOR_GD_RESULT_PATH}
    element={simulatorPage(<SalesSimulatorGdResultPage />)}
  />,
];
